import React, { Component } from 'react';
import AdminSalesForceSyncTable from './AdminSalesForceSyncTable';

export class AdminSalesForceSyncContent extends Component {
  render() {

    return (
      <AdminSalesForceSyncTable titleTableList={this.props.titleTableList} />
    )
  }
}

export default AdminSalesForceSyncContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminSalesForceSync/AdminSalesForceSyncContent.js